/** Web sign-in, sign-up, password reset and the desktop download hand-off. */
export default {
  signIn: "Sign in",
  signUp: "Sign up",
  name: "Name",
  email: "Email",
  password: "Password",
  confirm: "Confirm",
  emailPlaceholder: "you@example.com",
  passwordsDoNotMatch: "Passwords do not match.",
  sending: "Sending…",
  linkExpired: "Link expired",
  returnToDenker: "Return to Denker",
  openDenker: "Open Denker",
  loadingAuth: "Loading authentication state",
  backToLanding: "Back to Denker.ai",
  orDivider: "or",
  termsCreate:
    "By creating an account, you agree to the <terms>Terms</terms> and <privacy>Privacy Policy</privacy>. We use usage data to improve Denker. You can turn it off in Settings.",
  termsContinue:
    "By continuing, you agree to the <terms>Terms of Service</terms> and acknowledge the <privacy>Privacy Policy</privacy>.",
  termsDownload:
    "By downloading, you agree to the <terms>Terms of Service</terms> and acknowledge the <privacy>Privacy Policy</privacy>.",

  errorOauthFailed: "Google sign-in failed.",
  errorOauthCancelled: "Google sign-in cancelled.",
  errorEmailNotVerified: "Verify your email first.",
  errorSessionExpired: "Session expired.",
  errorUnknown: "Try again.",

  welcomeBack: "Welcome back",
  signInWithEmail: "Sign in with Email",
  signInWithGmail: "Sign in with Gmail",
  newsletterForUpdates: "Subscribe to the newsletter for updates",
  downloadOsApp: "Download the {os} app",
  forgotShort: "Forgot?",
  signingInStatus: "Signing in",
  signingIn: "Signing in…",
  backToSignInOptions: "Back to sign-in options",
  verificationEmailSent: "Verification email sent.",
  emailNotVerified: "Email not verified.",
  resend: "Resend",

  createYourAccount: "Create your account",
  signUpWithGmail: "Sign up with Gmail",
  creatingAccount: "Creating account…",
  createAccount: "Create account",
  checkEmail: "Check email",
  verificationLinkSent: "Verification link sent.",
  openMailProvider: "Open {provider}",

  resetPassword: "Reset password",
  checkYourEmail: "Check your email.",
  sendLink: "Send link",
  newPassword: "New password",
  invalidResetLink: "Invalid reset link.",
  passwordResetDone: "Password reset.",
  resetting: "Resetting…",
  reset: "Reset",
  finishResetInDenker: "Finish resetting your password in Denker.",
  nativeReturnFailed:
    "This return could not be prepared. Try again or reset your password here.",
  preparingReturn: "Preparing a secure return…",
  resetOnWebsite: "Reset on this website instead",

  invalidVerificationLink: "Invalid verification link.",
  verifying: "Verifying",
  emailVerified: "Email verified",
  returnToContinue: "Return to Denker to continue.",
  signingYouIn: "Signing you in…",
  verifyErrorNative:
    "Return to Denker to check verification or request a new link.",

  currentAccount: "Current account",
  connectOnThisMac: "Connect Denker on this Mac",
  continueAs: "Continue as {name}",
  switchAccount: "Switch account",

  openFailedHint:
    "Didn't open? Try again, or download and install Denker first.",
  signOut: "Sign out",
  downloadStarted: "Download started",
  openInstallerWindows: "Open the installer from your browser's downloads.",
  openInstallerMac:
    "Open it from your browser's downloads and drag Denker to Applications.",
  downloadAgain: "Didn't start? Download again",
  denkerForOs: "Denker for {os}",
  download: "Download",
  alreadyInstalled: "Already installed? Open Denker",
  runsOnDesktop: "Denker runs on your desktop",
  getDenkerForOs: "Get Denker for {os}",
} as const;
